import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { INVESTMENT_SCHEDULERS } from '@/common/paths';

export default (id: string) => {
  const { mutateAsync, isLoading, isSuccess } = useMutation(() =>
    api.delete(`${INVESTMENT_SCHEDULERS}/${id}`)
  );
  return {
    isSuccess,
    mutateAsync,
    isLoading,
  };
};
